export default {
  loading: 'Cargando...',
  noItemsFound: 'No se encontraron elementos',
  itemsWillAppear: 'Los elementos aparecerán aquí cuando estén disponibles',
  page: 'Página'
}
